export const LINKED_REWARD_VARIANT_VERSION = 1

const EXTERNAL_PROVIDERS = new Set(['Wogi', 'Edenred', 'Tremendous'])

const DISPLAY_FIELDS = [
  'rewards',
  'reward',
  'reward_en',
  'descriptions',
  'description',
  'description_en',
  'filepath',
  'filename',
  'tag',
  'type',
  'newtype',
  'country',
  'starton',
  'endon',
  'gift',
]

const FULFILLMENT_SNAPSHOT_FIELDS = [
  'provider',
  'productId',
  'price',
  'reward_currency',
  'feerate',
  'feerate_happily',
]

export function getMasterRewardId(reward: any, fallbackKey = ''): string {
  if (reward && typeof reward.master_reward_id === 'string' && reward.master_reward_id.trim()) {
    return reward.master_reward_id.trim()
  }
  return fallbackKey
}

export function findLinkedGemVariant(catalog: Record<string, any> = {}, masterRewardId: string) {
  const key = Object.keys(catalog || {}).find((catalogKey) => {
    const reward = catalog[catalogKey]
    return reward &&
      reward.master_reward_id === masterRewardId &&
      reward.currency_variant === 'gems'
  })

  return key ? { key, ...catalog[key] } : null
}

export function validateLinkedGemVariant(
  sourceReward: any,
  masterReward: any,
  gems: number,
) {
  const errors: string[] = []
  const warnings: string[] = []
  const gemCost = Number(gems)

  if (!sourceReward || !sourceReward.key) {
    errors.push('missing_source_reward')
  }
  if (!masterReward) {
    errors.push('missing_master_reward')
  }
  if (!Number.isInteger(gemCost) || gemCost <= 0) {
    errors.push('invalid_gem_cost')
  }

  if (masterReward) {
    if (masterReward.status === 'N') errors.push('inactive_master_reward')
    if (!masterReward.reward_en && !masterReward.reward) errors.push('missing_reward_name')
    if (!masterReward.newtype) errors.push('missing_reward_type')
    if (!(Number(masterReward.price) > 0)) errors.push('missing_face_value')
    if (!masterReward.reward_currency) errors.push('missing_reward_currency')

    const provider = masterReward.provider || 'Happily'
    if (EXTERNAL_PROVIDERS.has(provider) && !masterReward.productId) {
      errors.push('missing_provider_product_id')
    }
    if (!masterReward.provider) {
      warnings.push('happily_stock_fulfillment')
    }
  }

  return {
    valid: errors.length === 0,
    errors,
    warnings,
  }
}

export function buildLinkedGemVariant({
  sourceReward,
  masterReward,
  masterRewardId,
  company,
  gems,
  actor,
  now,
}: any) {
  const variant: any = {}

  DISPLAY_FIELDS.forEach((field) => {
    if (sourceReward && sourceReward[field] !== undefined) {
      variant[field] = sourceReward[field]
    }
  })
  FULFILLMENT_SNAPSHOT_FIELDS.forEach((field) => {
    if (masterReward && masterReward[field] !== undefined) {
      variant[field] = masterReward[field]
    }
  })

  return {
    ...variant,
    company,
    master_reward_id: masterRewardId,
    currency_variant: 'gems',
    linked_reward_variant_version: LINKED_REWARD_VARIANT_VERSION,
    coins: 0,
    gems: Number(gems),
    promotion: 'N',
    qty: 0,
    used: 0,
    monthly_period: null,
    status: 'Y',
    show: 'Y',
    oldreward: true,
    updateby: actor,
    updatetime: now,
    createtime: now,
  }
}
